import { merchantExclusivityOptions } from '../../campaigns/constants';
import ChangeMerchantExclusivityComment from './ChangeMerchantExclusivityComment';
import ChangeMerchantExclusivityForm from './ChangeMerchantExclusivityForm';

export default {
  label: 'Change Merchant Exclusivity',
  value: 'Change Merchant Exclusivity',
  Form: ChangeMerchantExclusivityForm,
  Comment: ChangeMerchantExclusivityComment,
  initialState: campaign => ({
    merchantExclusivity: merchantExclusivityOptions.find(
      option => option.value !== campaign.merchantExclusivity,
    ).value,
  }),
  patch: (campaign, change) => ({
    merchantExclusivity: change.merchantExclusivity,
  }),
};
